/* src/app/user-authorizations/user-authorization/user-authorization.component.scss */
body#themeTag :host ::ng-deep .p-togglebutton-content {
  padding: 0.2rem 0.75rem !important;
  border-radius: 4px !important;
}
.tabulator-edit-box input[type=number]::-webkit-outer-spin-button,
.tabulator-edit-box input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0 !important;
  display: none !important;
}
.tabulator-edit-box input[type=number] {
  -moz-appearance: textfield !important;
  appearance: textfield !important;
}
::ng-deep .tabulator input[type=number]::-webkit-outer-spin-button,
::ng-deep .tabulator input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0 !important;
  display: none !important;
}
::ng-deep .tabulator input[type=number] {
  -moz-appearance: textfield !important;
  appearance: textfield !important;
}
input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0 !important;
  display: none !important;
}
input[type=number] {
  -moz-appearance: textfield !important;
  appearance: textfield !important;
}
/*# sourceMappingURL=user-authorization.component.css.map */
